import { create } from 'zustand';
import { Location } from '../gql/graphql.generated';

interface AdminLocationState {
  actingLocation: Location | undefined;
  previousAdminLocation: Location | undefined;
  setActingLocation: (location: Location | undefined) => void;
  setPreviousAdminLocation: (location: Location | undefined) => void;
}

const STORAGE_KEY = 'admin-local-storage-location';
const PREVIOUS_ADMIN_LOCATION_STORAGE_KEY = 'admin-previous-location';

export const useAdminLocationStore = create<AdminLocationState>()(set => {
  let currentActingLocation: Location | undefined = undefined;
  let currentPreviousAdminLocation: Location | undefined = undefined;

  const localStored = localStorage.getItem(STORAGE_KEY);
  const previousAdminLocationStored = localStorage.getItem(PREVIOUS_ADMIN_LOCATION_STORAGE_KEY);

  if (localStored) {
    try {
      currentActingLocation = JSON.parse(localStored);
    } catch (error) {
      console.log('Unable to parse current acting location');
    }
  }

  if (previousAdminLocationStored) {
    try {
      currentPreviousAdminLocation = JSON.parse(previousAdminLocationStored);
    } catch (error) {
      console.log('Unable to parse previous admin location');
    }
  }

  return {
    actingLocation: currentActingLocation,
    previousAdminLocation: currentPreviousAdminLocation,
    setActingLocation: location => {
      if (location) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(location));
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
      set({ actingLocation: location });
    },
    setPreviousAdminLocation: location => {
      if (location) {
        localStorage.setItem(PREVIOUS_ADMIN_LOCATION_STORAGE_KEY, JSON.stringify(location));
      } else {
        localStorage.removeItem(PREVIOUS_ADMIN_LOCATION_STORAGE_KEY);
      }
      set({ previousAdminLocation: location });
    }
  };
});
